module.exports = __webpack_public_path__ + "img/32-e1f408.png";